import { environment } from '@zeusm/environment';

export function getAuthApiHost(): string {
  return environment.authApiUrl;
}

export function buildAuthApiUrl(path: string): string {
  return new URL(path.replace(/^\/+/, ''), ensureTrailingSlash(getAuthApiHost())).toString();
}

function ensureTrailingSlash(url: string): string {
  return url.endsWith('/') ? url : `${url}/`;
}
